<template>
  <div>
    <div class="container mx-auto flex-col flex md:justify-center">
      <div class="z-20 p-5 laptop:p-0 laptop:mt-150px">
        <MARSHeading><div v-html="$t('contacts.hero')" /></MARSHeading>
        <p
          class="text-standard my-8 laptop:w-full laptop:mt-12 laptop:mb-8 leading-relaxed"
          v-html="$t('contacts.hero-text')"
        />
      </div>
    </div>
    <div v-if="consentGivenForPurpose2" class="container mx-auto">
      <div id="mauticform_wrapper_mars2021contacts2" class="mauticform_wrapper">
        <form id="mauticform_mars2021contacts2"
              class="mx-4 mt-0 laptop:mx-24 laptop:my-150px"
              autocomplete="false"
              role="form"
              method="post"
              data-mautic-form="mars2021contacts2"
              enctype="multipart/form-data"
              action="https://ma.myarstudio.cloud/form/submit?formId=10"
        >
          <div
            id="mauticform_mars2021contacts2_error"
            class="mauticform-error"
          />
          <div
            id="mauticform_mars2021contacts2_message"
            class="mauticform-message"
          />
          <div class="mauticform-innerform">
            <div
              class="mauticform-page-wrapper mauticform-page-1 grid grid-cols-1 md:grid-cols-2 gap-x-32"
              data-mautic-form-page="1"
            >
              <div
                id="mauticform_mars2021contacts2_nome"
                data-validate="nome"
                data-validation-type="text"
                class="mauticform-row mauticform-text mauticform-field-1 mauticform-required"
              >
                <input
                  id="mauticform_input_mars2021contacts2_nome"
                  name="mauticform[nome]"
                  value=""
                  class="mauticform-input border-b border-formgray"
                  type="text"
                  :placeholder="$t('contacts.name').toString()"
                >
                <span class="mauticform-errormsg" style="display: none;"
                >This is required.</span
                >
              </div>

              <div
                id="mauticform_mars2021contacts2_cognome"
                data-validate="cognome"
                data-validation-type="text"
                class="mauticform-row mauticform-text mauticform-field-2 mauticform-required"
              >
                <input
                  id="mauticform_input_mars2021contacts2_cognome"
                  name="mauticform[cognome]"
                  value=""
                  class="mauticform-input border-b border-formgray"
                  type="text"
                  :placeholder="$t('contacts.surname').toString()"
                >
                <span class="mauticform-errormsg" style="display: none;"
                >This is required.</span
                >
              </div>

              <div
                id="mauticform_mars2021contacts2_email"
                data-validate="email"
                data-validation-type="email"
                class="mauticform-row mauticform-email mauticform-field-3 mauticform-required"
              >
                <input
                  id="mauticform_input_mars2021contacts2_email"
                  name="mauticform[email]"
                  value=""
                  class="mauticform-input border-b border-formgray"
                  type="email"
                  :placeholder="$t('contacts.email').toString()"
                >
                <span class="mauticform-errormsg" style="display: none;"
                >This is required.</span
                >
              </div>

              <div
                id="mauticform_mars2021contacts2_di_cosa_vuoi_discutere"
                data-validate="di_cosa_vuoi_discutere"
                data-validation-type="text"
                class="mauticform-row mauticform-text mauticform-field-4 mauticform-required"
              >
                <input
                  id="mauticform_input_mars2021contacts2_di_cosa_vuoi_discutere"
                  name="mauticform[di_cosa_vuoi_discutere]"
                  value=""
                  class="mauticform-input border-b border-formgray"
                  type="text"
                  :placeholder="$t('contacts.company').toString()"
                >
                <span class="mauticform-errormsg" style="display: none;"
                >This is required.</span
                >
              </div>

              <div
                id="mauticform_mars2021contacts2_telefono"
                data-validation-type="tel"
                class="mauticform-row mauticform-tel mauticform-field-5 "
              >
                <input
                  id="mauticform_input_mars2021contacts2_telefono"
                  name="mauticform[telefono]"
                  value=""
                  class="mauticform-input border-b border-formgray"
                  type="tel"
                  :placeholder="$t('contacts.phone').toString()"
                >
                <span class="mauticform-errormsg" style="display: none;" />
              </div>
            </div>
          </div>
          <h2 class="text-standard mt-12 xl:mt-24 laptop:text-55xl font-bold mb-12 md:w-1/2 laptop:w-9/12 md:text-4xl md:leading-normal laptop:leading-tight">
            {{ $t('contacts.message-title').toString() }}
          </h2>
          <div
            id="mauticform_mars2021contacts2_messaggio"
            class="mauticform-row mauticform-text mauticform-field-6"
          >
            <textarea
              id="mauticform_input_mars2021contacts2_messaggio"
              name="mauticform[messaggio]"
              class="mauticform-textarea border-b border-formgray"
              :placeholder="$t('contacts.message').toString()"
              style="height:128px"
            />
            <span class="mauticform-errormsg" style="display: none;" />
          </div>

          <div
            id="mauticform_mars2021contacts2_privacy_policy1"
            data-validate="privacy_policy1"
            data-validation-type="checkboxgrp"
            class="mauticform-row mauticform-checkboxgrp mauticform-field-7 mauticform-required text-sm mt-4 laptop:mt-12"
          >
            <div class="mauticform-checkboxgrp-row">
              <input
                id="mauticform_checkboxgrp_checkbox_privacy_policy1_Trattamentodatipersonali0"
                class="mauticform-checkboxgrp-checkbox"
                name="mauticform[privacy_policy1][]"
                type="checkbox"
                value="Trattamento dati personali"
              >&nbsp;
              <span v-html="$t('contacts.privacy', {privacyUrl: $t('links.privacy-policy')})" />
            </div>
            <span class="mauticform-errormsg" style="display: none;"
            >This is required.</span
            >
          </div>

          <div
            id="mauticform_mars2021contacts2_autorizzo_il_titolare"
            class="mauticform-row mauticform-checkboxgrp mauticform-field-8 text-sm "
          >
            <div class="mauticform-checkboxgrp-row">
              <input
                id="mauticform_checkboxgrp_checkbox_autorizzo_il_titolare_11"
                class="mauticform-checkboxgrp-checkbox"
                name="mauticform[autorizzo_il_titolare][]"
                type="checkbox"
                value="Yes"
              >&nbsp;
              <span v-html="$t('contacts.newsletter').toString()" />
            </div>
            <span class="mauticform-errormsg" style="display: none;" />
          </div>

          <div id="mauticform_mars2021contacts2_captcha" class="mauticform-row mauticform-div-wrapper mauticform-field-9">
            <div class="g-recaptcha" data-sitekey="6LcejeQpAAAAAMs9bnjHSt1l3ijgOyRaeChv8HhQ" data-callback="verifyCallback_9a20cbe8833b675b10ed847d2c96c672" />        <input id="mauticform_input_mars2021contacts2_captcha" name="mauticform[captcha]" value="" class="mauticform-input" type="hidden">
            <span class="mauticform-errormsg" style="display: none;" />
          </div>
          <div
            id="mauticform_mars2021contacts2_submit"
            class="mauticform-row mauticform-button-wrapper mauticform-field-9 mt-4"
          >
            <button
              id="mauticform_input_mars2021contacts2_submit"
              type="submit"
              name="mauticform[submit]"
              value=""
              class="mauticform-button rounded bg-highlight text-white hover:border-highlight"
            >
              {{ $t('contacts.send') }}
            </button>
          </div>

          <input
            id="mauticform_mars2021contacts2_id"
            type="hidden"
            name="mauticform[formId]"
            value="10"
          >
          <input
            id="mauticform_mars2021contacts2_return"
            type="hidden"
            name="mauticform[return]"
            value=""
          >
          <input
            id="mauticform_mars2021contacts2_name"
            type="hidden"
            name="mauticform[formName]"
            value="mars2021contacts2"
          >
        </form>
      </div>
    </div>
    <div v-else class="m-5 mx-10 p-5 text-white border-2 border-dashed w-full">
      <p>Form disabled because of your cookie preferences.</p>
      <p>To enable it please review your cookie preferences:</p>
      <a class="block text-sm mt-4 hover:text-highlight text-standard tracking-widest uppercase cursor-pointer" @click="clickIubenda"> -> Cookie preferences</a>
    </div>
  </div>
</template>

<script lang="ts" setup>
declare global {
  interface Window {
    MauticSDK: any
    MauticDomain: string
    MauticLang: object
    verifyCallback_9a20cbe8833b675b10ed847d2c96c672: (response: any) => void
    grecaptcha: any
  }
}

import { useIubenda } from 'mars-iubenda-vite';

const {consentGivenForPurpose2} = useIubenda()
updateReCaptcha(consentGivenForPurpose2.value)

watch(consentGivenForPurpose2, (current) => {
  updateReCaptcha(current)
})

function updateReCaptcha(enable: boolean) {
  if (enable) {
    const script = document.createElement('script')
    script.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
    script.setAttribute('async', 'true')
    script.setAttribute('defer', 'true')
    document.head.appendChild(script)
  }
}

const clickIubenda = () => {
  (document.querySelector('a.iubenda-cs-preferences-link') as HTMLElement)?.click()
}

const onLoad9a20cbe8833b675b10ed847d2c96c672 = () => {
  window.grecaptcha.execute('6LcejeQpAAAAAMs9bnjHSt1l3ijgOyRaeChv8HhQ', { action: 'form' }).then((token: any) => {
    window.verifyCallback_9a20cbe8833b675b10ed847d2c96c672(token)
  })
}

onMounted(() => {
  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://ma.myarstudio.cloud/media/js/mautic-form.js?v52edc655'
  
  script.onload = function() {
    window.MauticSDK.onLoad()
  }
  
  head.appendChild(script)
  
  window.MauticDomain = 'https://ma.myarstudio.cloud'
  window.MauticLang = {
    submittingMessage: 'Please wait...',
  }
  
  window.verifyCallback_9a20cbe8833b675b10ed847d2c96c672 = (response: any) => {
    (document.getElementById('mauticform_input_mars2021contacts2_captcha')! as HTMLInputElement).value = response
  }
})
</script>

<style scoped>
.mauticform-name {
  font-weight: bold;
  font-size: 1.5em;
  margin-bottom: 3px;
}

.mauticform-description {
  margin-top: 2px;
  margin-bottom: 10px;
}

.mauticform-error {
  margin-bottom: 10px;
  color: red;
}

.mauticform-message {
  margin-bottom: 10px;
  color: green;
}

.mauticform-row {
  display: block;
  margin-bottom: 20px;
}

.mauticform-label {
  font-size: 1.1em;
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.mauticform-row.mauticform-required .mauticform-label:after {
  color: #e32;
  content: " *";
  display: inline;
}

.mauticform-helpmessage {
  display: block;
  font-size: 0.9em;
  margin-bottom: 3px;
}

.mauticform-errormsg {
  display: block;
  color: red;
  margin-top: 2px;
}

.mauticform-selectbox,
.mauticform-input,
.mauticform-textarea {
  width: 100%;
  padding: 0.5em 0.5em;
  background: #fff;
  box-sizing: border-box;
}

.mauticform-checkboxgrp-label {
  font-weight: normal;
}

.mauticform-radiogrp-label {
  font-weight: normal;
}

.mauticform-pagebreak-wrapper .mauticform-button-wrapper {
  display: inline;
}

span >>> a {
  text-decoration: underline;
}
</style>
